(function () {
  // Fills the [data-local-estimate] anchors rendered by
  // snippets/local-price-estimate.liquid with "(approx. EUR 164)".
  //
  // Rate source: fawazahmed0/currency-api, base AED, keyless, served from
  // jsDelivr with the project's own mirror as fallback. The published date is
  // validated so a feed that stops updating cannot keep feeding a stale rate:
  // any failure path leaves the anchors empty, which CSS hides. There is
  // deliberately no hardcoded fallback rate.
  const CACHE_KEY = 'artsight-fx-aed-v1';
  const MAX_PUBLISHED_AGE_MS = 7 * 24 * 60 * 60 * 1000;
  const FETCH_TIMEOUT_MS = 5000;
  const ENDPOINTS = [
    'https://cdn.jsdelivr.net/npm/@fawazahmed0/currency-api@latest/v1/currencies/aed.min.json',
    'https://latest.currency-api.pages.dev/v1/currencies/aed.min.json',
  ];

  let inflight = null;

  function validRate(x) {
    return typeof x === 'number' && isFinite(x) && x > 0;
  }

  function validRates(rates) {
    return !!rates && validRate(rates.EUR) && validRate(rates.CHF) && validRate(rates.SAR);
  }

  function readCache() {
    try {
      const parsed = JSON.parse(sessionStorage.getItem(CACHE_KEY));
      if (!parsed || typeof parsed.fetchedAt !== 'number' || !validRates(parsed.rates)) return null;
      return parsed.rates;
    } catch (e) {
      return null;
    }
  }

  function writeCache(rates) {
    try {
      sessionStorage.setItem(CACHE_KEY, JSON.stringify({ fetchedAt: Date.now(), rates: rates }));
    } catch (e) {
      /* private mode etc.: estimates then simply refetch per page */
    }
  }

  async function fetchRates() {
    for (const url of ENDPOINTS) {
      const controller = new AbortController();
      const timer = setTimeout(() => controller.abort(), FETCH_TIMEOUT_MS);
      try {
        const res = await fetch(url, { signal: controller.signal });
        if (!res.ok) continue;
        const data = await res.json();
        const published = Date.parse(data && data.date);
        if (!isFinite(published) || Date.now() - published > MAX_PUBLISHED_AGE_MS) continue;
        const aed = data.aed || {};
        const rates = { EUR: aed.eur, CHF: aed.chf, SAR: aed.sar };
        if (validRates(rates)) return rates;
      } catch (e) {
        /* timeout or network error: try the next endpoint */
      } finally {
        clearTimeout(timer);
      }
    }
    return null;
  }

  function getRates() {
    const cached = readCache();
    if (cached) return Promise.resolve(cached);
    if (!inflight) {
      inflight = fetchRates().then((rates) => {
        inflight = null;
        if (rates) writeCache(rates);
        return rates;
      });
    }
    return inflight;
  }

  function fillAll() {
    const anchors = document.querySelectorAll('[data-local-estimate]:empty');
    if (!anchors.length) return;
    getRates().then((rates) => {
      if (!rates) return;
      anchors.forEach((el) => {
        const subunits = Number(el.dataset.aedSubunits);
        const rate = rates[el.dataset.currency];
        if (!isFinite(subunits) || subunits <= 0 || !validRate(rate)) return;
        // Whole units only: decimals would imply a precision the conversion
        // does not have.
        const approx = Math.round((subunits / 100) * rate);
        el.textContent = '(approx. ' + el.dataset.currency + ' ' + approx + ')';
      });
    });
  }

  // Cart quantity changes and variant switches re-render price fragments via
  // section HTML swaps, which recreate empty anchors.
  let debounceTimer;
  new MutationObserver(() => {
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(fillAll, 150);
  }).observe(document.documentElement, { childList: true, subtree: true });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', fillAll);
  } else {
    fillAll();
  }
})();
